import { useMemo } from "react";

// Memoised because the result is a dependency of the series hooks below it. A
// fresh array on every render made those recompute, which handed the charts a
// new series object, which made them redraw — so with the refresh timer's
// one-second countdown ticking, every chart on the page redrew every second.
export function useDaysSorted(raw) {
  return useMemo(() => {
    if (!raw) return [];

    const parse = (key) => {
      const [d, m, y] = key.split("-").map(Number);
      return new Date(y, m - 1, d).getTime();
    };

    return Object.keys(raw)
      .filter((k) => /^\d{2}-\d{2}-\d{4}$/.test(k))
      .sort((a, b) => parse(a) - parse(b));
  }, [raw]);
}
